import React, { FC } from 'react';
import TitleReviewsAndLocation from '../_reusable/houseInfo/basicInfo/titleReviewsAndLocation/TitleReviewsAndLocation';
import Box from '@/components/UI/box/Box';
import MobileActiveReserveStatus from './mobileActiveReserveStatus/MobileActiveReserveStatus';
import HouseInfo from '@/components/houses/_reusable/houseInfo/HouseInfo';
import useHouse from '@/components/houses/_hooks/useHouse';
import TopNavbar from '@/components/houses/housesMobile/topNavbar/TopNavbar';
import GoftinoSection from '@/components/houses/housesMobile/goftinoSection/GoftinoSection';
import PriceBoxMobile from './priceBoxMobile/PriceBoxMobile';
import HouseInfoFooter from '../_reusable/houseInfoFooter/HouseInfoFooter';
import useDrawer from '@/hooks/useDrawer';
import { useMidTermQuery } from '../_hooks/useMidterm';
import { ProductItemTypes } from '../_types/productItem.types';
type HousesMobileProps = {
  data: ProductItemTypes;
  host: string;
};
const HousesMobile: FC<HousesMobileProps> = ({
  data,
  host
}) => {
  const {
    drawerOpen
  } = useDrawer();
  const {
    loading,
    calendarPricing,
    onSendReserveRequestClick,
    displayGoftinoSection,
    setDisplayGoftinoSection,
    isNonBookable
  } = useHouse(data);
  const {
    isMidTerm
  } = useMidTermQuery(data);
  const orderId = data?.order_tracking;
  return <Box component={'main'} data-sentry-element="Box" data-sentry-component="HousesMobile" data-sentry-source-file="HousesMobile.tsx">
      <Box component={'article'} data-sentry-element="Box" data-sentry-source-file="HousesMobile.tsx">
        <Box component={'header'} data-sentry-element="Box" data-sentry-source-file="HousesMobile.tsx">
          <TopNavbar productState={data} data-sentry-element="TopNavbar" data-sentry-source-file="HousesMobile.tsx" />
          <TitleReviewsAndLocation productState={data} data-sentry-element="TitleReviewsAndLocation" data-sentry-source-file="HousesMobile.tsx" />
        </Box>
        {!isMidTerm && orderId && <MobileActiveReserveStatus orderId={orderId as string} />}
        <HouseInfo productState={data} calendarPricing={calendarPricing} host={host} data-sentry-element="HouseInfo" data-sentry-source-file="HousesMobile.tsx" />
      </Box>
      <HouseInfoFooter productState={data} host={host} data-sentry-element="HouseInfoFooter" data-sentry-source-file="HousesMobile.tsx" />
      {displayGoftinoSection && <GoftinoSection isMidTerm={isMidTerm} handleCloseSecttion={() => setDisplayGoftinoSection(false)} />}

      <PriceBoxMobile isNonBookable={isNonBookable} loading={loading} calendarPricing={calendarPricing} productState={data} openComments={() => drawerOpen('REVIEWS')} onSendReserveRequestClick={onSendReserveRequestClick} data-sentry-element="PriceBoxMobile" data-sentry-source-file="HousesMobile.tsx" />
    </Box>;
};
export default HousesMobile;